// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__gXpoe","layout-content":"layout_layout-content__jj2d7"};